import { render, staticRenderFns } from "./questionRadios.vue?vue&type=template&id=da516ed0&scoped=true&"
import script from "./questionRadios.vue?vue&type=script&lang=js&"
export * from "./questionRadios.vue?vue&type=script&lang=js&"
import style0 from "./questionRadios.vue?vue&type=style&index=0&id=da516ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da516ed0",
  null
  
)

export default component.exports